import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { FacturacionElectronicaConsultarEstadoFactura } from './ConsultarEstadoFactura.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ConsultarEstadoDocumento',
        component: FacturacionElectronicaConsultarEstadoFactura,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ConsultarEstadoDocumento'
        } 
    }
];

@NgModule({
    declarations: [
        FacturacionElectronicaConsultarEstadoFactura
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        FacturacionElectronicaConsultarEstadoFactura
    ],
    bootstrap: [FacturacionElectronicaConsultarEstadoFactura]
})

export class FacturacionElectronicaConsultarEstadoFacturaModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaConsultarEstadoFactura/ConsultarEstadoFactura.module.ts